import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { makeStyles, Link as LinkMaterial } from '@material-ui/core';

import LinkRouter from '../LinkRouter';

import { useDropdownContext } from './Context';

import styles from './styles';

const useStyles = makeStyles(styles);

const DropdownLink = ({ title, path }) => {
  const classes = useStyles();

  const { toggleOpen } = useDropdownContext();

  const isExternalPath = useMemo(() => path.match(/^http|^https|^www/), [path]);

  if (isExternalPath) {
    return (
      <LinkMaterial
        href={path}
        underline="none"
        color="inherit"
        className={classes.collpaseBtn}
        onClick={toggleOpen}
      >
        {title}
      </LinkMaterial>
    );
  }

  return (
    <LinkRouter
      to={path}
      color="inherit"
      underline="none"
      className={classes.collpaseBtn}
      onClick={toggleOpen}
    >
      {title}
    </LinkRouter>
  );
};

DropdownLink.propTypes = {
  title: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired,
};

export default DropdownLink;
